export default [
    {
        path: '/changelog',
        name: 'changelog',
        component: () => import('@/views/changelog/VChangelog.vue'),
        meta: {
            requiresAuth: true
        }
    }
]
